/**
 * Bit flags used to scope a timesheet to a user or a project.
 */
export enum TimesheetScopes {
  Project = 1 << 0,
  User = 1 << 1,
  All = TimesheetScopes.Project | TimesheetScopes.User,
}
